import { render, staticRenderFns } from "./Lgx02667342160782000390436.vue?vue&type=template&id=83ec70c8&"
import script from "./Lgx02667342160782000390436.vue?vue&type=script&lang=js&"
export * from "./Lgx02667342160782000390436.vue?vue&type=script&lang=js&"
import style0 from "./Lgx02667342160782000390436.vue?vue&type=style&index=0&id=83ec70c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports